import Toggle from 'src/autobahn/components/toggle';
import useAlerts from 'src/hooks/use-alerts';
import {Integration} from 'src/core/data/api/Integration';
import {AccessOwner, useIntegrationAccess, useSetIntegrationAccess} from './access';

interface IntegrationAccessTogglesProps {
  owner: AccessOwner;
  /** Ausente enquanto o dono ainda não existe: aí a seleção fica com o formulário. */
  ownerId?: number;
  integrations: Integration[];
  value?: number[];
  onChange?: (integrationIds: number[]) => void;
}

/**
 * Um toggle por integração. Com dono já gravado, cada clique vai direto para o servidor; sem dono
 * (criação), a seleção sobe para o formulário, que grava depois de receber o id.
 */
const IntegrationAccessToggles = ({
  owner, ownerId, integrations, value, onChange,
}: IntegrationAccessTogglesProps) => {
  const {toast} = useAlerts();
  const {data: granted} = useIntegrationAccess(owner, ownerId);
  const {mutate: setAccess, isPending} = useSetIntegrationAccess(owner);

  const checkedIds = ownerId ? granted : value ?? [];

  const onToggle = (integrationId: number, checked: boolean) => {
    if (!ownerId) {
      const next = checked ?
        [...checkedIds, integrationId] :
        checkedIds.filter((id) => id !== integrationId);
      onChange?.(next);
      return;
    }

    setAccess({ownerId, integrationId, granted: checked}, {
      onError: (error: unknown) => {
        const apiError = error as {data?: string; status?: number};
        toast.errorStatus({data: apiError?.data, status: apiError?.status ?? 500});
      },
    });
  };

  return (
    <>
      {integrations.map((integration) => (
        <Toggle
          key={integration.id}
          checked={checkedIds.includes(integration.id)}
          disabled={isPending}
          onChange={(checked) => onToggle(integration.id, checked)}
          label={integration.title}
        />
      ))}
    </>
  );
};

export default IntegrationAccessToggles;
